// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__17Da5","list":"BalanceDue_list__39Snw","listRow":"BalanceDue_listRow__1SX71","total":"BalanceDue_total__2N6WG"};